var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: "Invoice Apply", isShowFollow: false },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c("el-form", { ref: "form", attrs: { model: _vm.form } }, [
                  _c(
                    "table",
                    {
                      staticClass: "mailTable",
                      staticStyle: { width: "100%", "margin-bottom": "0" },
                    },
                    [
                      _c("colgroup", [
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                        _vm._v(" "),
                        _c("col", { attrs: { width: "100px" } }),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "column", attrs: { colspan: "2" } },
                          [
                            _c("span", { staticClass: "column-after" }, [
                              _vm._v(
                                _vm._s(_vm.$t("exportCostSlipUpload.invoiceNo"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "invoiceNo" } },
                              [
                                _c("el-input", {
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.form.invoiceNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceNo", $$v)
                                    },
                                    expression: "form.invoiceNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "column", attrs: { colspan: "6" } },
                          [
                            _c("span", { staticClass: "column-after" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("exportCostSlipUpload.InvoiceCurrency")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "currency" } },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.form.currency,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "currency", $$v)
                                      },
                                      expression: "form.currency",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: "01" } }, [
                                      _vm._v("CNY"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "02" } }, [
                                      _vm._v("USD"),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "03" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "exportCostSlipUpload.cnyUsdBillingSeparately"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: "04" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("exportCostSlipUpload.onlyCNY")
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _vm.form.currency == "01"
                          ? _c(
                              "td",
                              {
                                staticClass: "column ",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v("CNY"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "amountICNY" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountICNY,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountICNY", $$v)
                                        },
                                        expression: "form.amountICNY",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.currency == "02"
                          ? _c(
                              "td",
                              {
                                staticClass: "column ",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v("USD"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "amountIUSD" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountIUSD,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountIUSD", $$v)
                                        },
                                        expression: "form.amountIUSD",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.currency == "04"
                          ? _c(
                              "td",
                              {
                                staticClass: "column ",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v("CNY"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "amountIORMB" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountIORMB,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "amountIORMB", $$v)
                                        },
                                        expression: "form.amountIORMB",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.currency == "03"
                          ? _c(
                              "td",
                              {
                                staticClass: "column ",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v("CNY"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "amountIDistinction1" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountIDistinction1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "amountIDistinction1",
                                            $$v
                                          )
                                        },
                                        expression: "form.amountIDistinction1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.currency == "03"
                          ? _c(
                              "td",
                              {
                                staticClass: "column ",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v("USD"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "amountIDistinction2" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountIDistinction2,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "amountIDistinction2",
                                            $$v
                                          )
                                        },
                                        expression: "form.amountIDistinction2",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.form.currency == "03"
                          ? _c(
                              "td",
                              {
                                staticClass: "column ",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v("HKD"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "amountIDistinction3" } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: _vm.form.amountIDistinction3,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "amountIDistinction3",
                                            $$v
                                          )
                                        },
                                        expression: "form.amountIDistinction3",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "column", attrs: { colspan: "2" } },
                          [
                            _c("span", { staticClass: "column-after" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("exportCostSlipUpload.invoiceWay")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "invoiceWay" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.form.invoiceWay,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "invoiceWay", $$v)
                                      },
                                      expression: "form.invoiceWay",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "exportCostSlipUpload.paper"
                                        ),
                                        value: "01",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-option", {
                                      attrs: {
                                        label: _vm.$t(
                                          "exportCostSlipUpload.electronics"
                                        ),
                                        value: "02",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "column", attrs: { colspan: "2" } },
                          [
                            _c("span", { staticClass: "column-after" }, [
                              _vm._v(
                                _vm._s(_vm.$t("exportCostSlipUpload.soaNo"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "soaNo" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.form.soaNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "soaNo", $$v)
                                    },
                                    expression: "form.soaNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "column", attrs: { colspan: "2" } },
                          [
                            _c("span", { staticClass: "column-after" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("exportCostSlipUpload.invoiceNumber")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "invoiceNumber" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.form.invoiceNumber,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "invoiceNumber", $$v)
                                    },
                                    expression: "form.invoiceNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "p-color" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("exportCostSlipUpload.payeeContactShipping")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "p-color" }, [
                    _vm._v(
                      _vm._s(_vm.$t("exportCostSlipUpload.updateInvoiceInfo"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "p-color" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("exportCostSlipUpload.onlyElectronicInvoice")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "p-color" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("exportCostSlipUpload.updateEmailForInvoice")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "item-button" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          on: { click: _vm.handleSave },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("btn.save")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }